import React from 'react' ;
const RegionDetection = ({RegionDetect}) => {
    return(
        <div className='center'>
        <div className='f1 h1 center grow pa3'>
             {RegionDetect}
        </div>
        </div>
    );
}
export default RegionDetection;